export class GetActivityLogsRequestModel {
    PageNumber: number;
    PageSize: number;
    LogType?: string;
    PerformedBy?: string;
    SearchText?: string;
    FromDate?: string;
    ToDate?: string;
    SortColumn?: string;
    SortOrder?: string;
    Company: string;
    DocType: string;
    DocCabinet: string;
    CompanyId?: number;
}

export class GetAdminActivityLogsRequestModel {
    PageNumber: number;
    PageSize: number;
    LogType?: string;
    CompanyId?: number;
    PerformedBy?: string;
    SearchText?: string;
    SortColumn?: string;
    SortOrder?: string;
    FromDate?: string;
    ToDate?: string;
}